export default __webpack_public_path__ + "static/media/newCreateDemat.9bbca179.png";